import SockJS from "sockjs-client/dist/sockjs.min";
import { Client } from "@stomp/stompjs";

document.addEventListener("DOMContentLoaded", function () {
  const startVideoBtn = document.getElementById("startVideoCallBtn");
  if (!startVideoBtn) return; // Only execute if button is present

  const avatarContainer = document.getElementById("offcanvasAvatarContainer");
  const videoContainer = document.getElementById("offcanvasVideoContainer");
  const statusOverlay = document.getElementById("advisorStatusOverlay");
  const statusText = document.getElementById("advisorStatusText");

  let callToken = null;
  let advisorLocalStream = null;
  let advisorPeerConnection = null;
  let advisorStompClient = null;
  let turnConfig = null;

  let isVideoActive = false;

  startVideoBtn.addEventListener("click", async () => {
    if (isVideoActive) {
      endAdvisorCallLocally();
      return;
    }

    startVideoBtn.disabled = true;
    startVideoBtn.innerHTML =
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Starten...';

    const contactId = startVideoBtn.getAttribute("data-contact-id");
    const csrfToken = document.querySelector("meta[name='_csrf']")?.getAttribute("content");
    const csrfHeader = document.querySelector("meta[name='_csrf_header']")?.getAttribute("content");

    try {
      const response = await fetch(`/contact/api/call/start-video/${contactId}`, {
        method: "POST",
        headers: {
          ...(csrfHeader && csrfToken ? { [csrfHeader]: csrfToken } : {}),
        },
      });

      if (response.ok) {
        const data = await response.json();
        callToken = data.token;
        turnConfig = {
          url: data.turnUrl,
          username: data.turnUsername,
          secret: data.turnSecret,
        };

        // Switch UI
        isVideoActive = true;
        startVideoBtn.disabled = false;
        startVideoBtn.classList.remove("btn-primary");
        startVideoBtn.classList.add("btn-danger");
        startVideoBtn.innerHTML = '<i class="bi bi-camera-video-off"></i>';

        const msgEl = document.getElementById("videoInviteSentMessage");
        if (msgEl) msgEl.style.display = "block";
        avatarContainer.style.display = "none";
        videoContainer.style.display = "block";

        await initAdvisorVideo();
      } else {
        const errData = await response.json();
        alert("Fehler beim Starten des Videos: " + (errData.error || response.statusText));
        startVideoBtn.disabled = false;
        startVideoBtn.innerHTML = '<i class="bi bi-camera-video"></i>';
      }
    } catch (e) {
      console.error("Error starting video call:", e);
      alert("Fehler beim Starten des Videos.");
      startVideoBtn.disabled = false;
      startVideoBtn.innerHTML = '<i class="bi bi-camera-video"></i>';
    }
  });

  async function initAdvisorVideo() {
    try {
      advisorLocalStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      document.getElementById("advisorLocalVideo").srcObject = advisorLocalStream;

      const socket = new SockJS("/ws", null, {
        transports: ["websocket"],
      });

      advisorStompClient = new Client({
        webSocketFactory: () => socket,
        reconnectDelay: 5000,
        debug: (str) => console.log("[Advisor WebSocket]", str),
        onConnect: () => {
          console.log("Advisor STOMP connected");
          advisorStompClient.subscribe("/topic/videocall/" + callToken, function (message) {
            handleAdvisorSignaling(JSON.parse(message.body));
          });
        },
        onStompError: (frame) => {
          console.error("STOMP connection error", frame.headers["message"]);
          statusText.innerText = "Verbindungsfehler";
        },
        onWebSocketError: (event) => {
          console.error("WebSocket connection error", event);
          statusText.innerText = "Verbindungsfehler";
        },
      });

      advisorStompClient.activate();
    } catch (e) {
      console.error("Error accessing media devices", e);
      statusText.innerText = "Kamera/Mikrofon blockiert.";
    }
  }

  function endAdvisorCallLocally() {
    sendAdvisorSignal({
      type: "LEAVE",
      sender: "ADVISOR",
    });

    if (advisorStompClient) {
      advisorStompClient.deactivate();
      advisorStompClient = null;
    }
    if (advisorPeerConnection) {
      advisorPeerConnection.close();
      advisorPeerConnection = null;
    }
    if (advisorLocalStream) {
      advisorLocalStream.getTracks().forEach((t) => t.stop());
      advisorLocalStream = null;
    }

    // Revert UI
    isVideoActive = false;
    startVideoBtn.classList.remove("btn-danger");
    startVideoBtn.classList.add("btn-primary");
    startVideoBtn.innerHTML = '<i class="bi bi-camera-video"></i>';

    const msgEl = document.getElementById("videoInviteSentMessage");
    if (msgEl) msgEl.style.display = "none";

    videoContainer.style.display = "none";
    avatarContainer.style.display = "block";
    statusOverlay.style.display = "flex";
    statusText.innerText = "Warten auf Kontakt...";
  }

  function sendAdvisorSignal(msg) {
    if (advisorStompClient && advisorStompClient.connected) {
      advisorStompClient.publish({
        destination: "/app/videocall/signal/" + callToken,
        body: JSON.stringify(msg),
      });
    }
  }

  async function handleAdvisorSignaling(msg) {
    if (msg.sender === "ADVISOR") return;

    switch (msg.type) {
      case "JOIN":
        statusText.innerText = "Kontakt verbunden. Baue Verbindung auf...";
        await initiateCall();
        break;
      case "ANSWER":
        if (advisorPeerConnection) {
          await advisorPeerConnection.setRemoteDescription(new RTCSessionDescription(msg.answer));
        }
        break;
      case "ICE":
        if (advisorPeerConnection && msg.candidate) {
          try {
            await advisorPeerConnection.addIceCandidate(msg.candidate);
          } catch (e) {
            console.error("Error adding ICE", e);
          }
        }
        break;
      case "LEAVE":
        statusOverlay.style.display = "flex";
        statusText.innerText = "Kontakt hat aufgelegt.";
        break;
      case "LEAVE":
        endAdvisorCallLocally();
        break;
    }
  }

  async function initiateCall() {
    const configuration = { iceServers: [{ urls: "stun:stun.l.google.com:19302" }] };
    if (turnConfig && turnConfig.url && turnConfig.username && turnConfig.secret) {
      configuration.iceServers.push({
        urls: turnConfig.url,
        username: turnConfig.username,
        credential: turnConfig.secret,
      });
    }
    advisorPeerConnection = new RTCPeerConnection(configuration);

    advisorLocalStream.getTracks().forEach((track) => {
      advisorPeerConnection.addTrack(track, advisorLocalStream);
    });

    advisorPeerConnection.ontrack = (event) => {
      statusOverlay.style.display = "none";
      const remoteVideo = document.getElementById("advisorRemoteVideo");
      if (!remoteVideo.srcObject) {
        remoteVideo.srcObject = event.streams[0];
      }
    };

    advisorPeerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        sendAdvisorSignal({
          type: "ICE",
          sender: "ADVISOR",
          candidate: event.candidate,
        });
      }
    };

    try {
      const offer = await advisorPeerConnection.createOffer();
      await advisorPeerConnection.setLocalDescription(offer);
      sendAdvisorSignal({ type: "OFFER", sender: "ADVISOR", offer: offer });
    } catch (e) {
      console.error("Error creating offer", e);
    }
  }

  // Handle End Call logic specifically for WebRTC resources cleanup
  const endBtn = document.getElementById("endCallBtn");
  if (endBtn) {
    endBtn.addEventListener("click", () => {
      endAdvisorCallLocally();
    });
  }

  // Fullscreen Toggle
  const fullscreenBtn = document.getElementById("advisorFullscreenBtn");
  if (fullscreenBtn) {
    fullscreenBtn.addEventListener("click", () => {
      const container = videoContainer; // Or a specific wrapper
      if (!document.fullscreenElement) {
        if (container.requestFullscreen) {
          container.requestFullscreen();
        } else if (container.webkitRequestFullscreen) {
          /* Safari */
          container.webkitRequestFullscreen();
        } else if (container.msRequestFullscreen) {
          /* IE11 */
          container.msRequestFullscreen();
        }
        fullscreenBtn.innerHTML = '<i class="bi bi-fullscreen-exit"></i>';
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen();
        }
        fullscreenBtn.innerHTML = '<i class="bi bi-arrows-fullscreen"></i>';
      }
    });
  }
});
